﻿import { Directive } from "@app/components/directive";
import { NgComponent } from "@app/di/decorators";
import { Token } from "@app/di/token";
import { Dirs } from "@app/helpers/dirs";
import { keyboard } from "@tools";

export interface IEditScope extends ng.IScope {
    ngModel: string;
    enabled: boolean;

    // internal scope properties
    _editing: boolean;
    _click: () => void;
    _blur: () => void;
    _keydown: ($event: JQueryEventObject) => void;
}

@NgComponent({
    token: Token.KbEdit,
    dependencies: [
        Token.$Timeout
    ]
})
export class KbEdit extends Directive {
    constructor($timeout: ng.ITimeoutService) {
        super();

        this.restrict = "E";
        this.template = Dirs.component("kb-edit");
        this.scope = {
            ngModel: "=",
            enabled: "=?"
        };
        this.replace = true;

        this.link = (scope: IEditScope, element, atts) => {

            let input = $(element).find("input");

            if (typeof scope.enabled == "undefined") scope.enabled = true;

            scope.$watch("enabled", newValue => {
                if (!newValue) {
                    scope._editing = false;
                    input.hide();
                }
            });

            scope._click = () => {
                if (!scope.enabled) return;
                scope._editing = true;
                input.show();
                input.focus();
            };

            scope._blur = () => {
                scope._editing = false;
                input.hide();
            };

            scope._keydown = $event => {
                $event.stopPropagation();
                if ($event.keyCode == keyboard.enter) {
                    scope._editing = false;
                    input.hide();
                }
            };
        };
    }
}
